module.exports = __webpack_public_path__ + "img/logo.c9f7ebc3.png";